import React, { useEffect, useRef } from "react";
import { Button, Card, CardBody, Col, Container, Input, Label, Row, Spinner } from "@/Components/ui";
;
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import moment from "moment";
import { API_USERS_CRM, getDataFromUrl } from "../../../api";
import { BACKEND_HOST } from "../../../api";
import { postData } from "../../../api";
import { SITE_ID } from "../../../assets/meta/meta";
import UserSelectBox from "../../../Components/Common/UserSelectBox";
import toast, { Toaster } from 'react-hot-toast';
import { dialogService } from "@/utils/dialogService";
const UserSendCoupon = ({ history }) => {
    const [target, setTarget] = React.useState("user");
    const [userList, setUserList] = React.useState([]);
    const [search, setSearch] = React.useState("");
    const [count, setCount] = React.useState(0);
    const [selectedUsers, setSelectedUsers] = React.useState([]);
    const [isSending, setIsSending] = React.useState(false);
    const [couponList, setCouponList] = React.useState([]);
    const abortController = useRef(null);
    const [selectedCoupon, setSelectedCoupon] = React.useState(0);
    const [couponCount, setCouponCount] = React.useState(1);
    useEffect(() => {
        console.log("selectedUsers", selectedUsers);
    }, [selectedUsers]);
    useEffect(() => {
        if (couponList && couponList.length > 0) {
            let coupon = couponList?.find((item) => moment(item["expire_date"]) > moment());
            if (coupon) {
                setSelectedCoupon(coupon.id);
            }
        }
    }, [couponList]);
    useEffect(() => {
        if (abortController.current) {
            abortController.current.abort();
        }
        if (search) {
            abortController.current = new AbortController();
            getDataFromUrl(`${API_USERS_CRM}/?search=${search}`, abortController.current.signal)
                .then((data) => {
                console.log(data);
                setUserList(data.results);
                setCount(data.count);
            })
                .catch((e) => {
                console.log(e);
            });
        }
    }, [search]);
    const handleSelectedCoupon = (e) => {
        setSelectedCoupon(e.target.value);
        console.log("selectedCoupon", e.target.value);
    };
    useEffect(() => {
        getDataFromUrl(`${BACKEND_HOST}/coupon/products/?include_hidden=true`, null)
            .then((data) => {
            console.log("couponList", data);
            setCouponList(data);
        })
            .catch((e) => {
            console.log(e);
        });
    }, []);
    const sendToCustomers = async () => {
        if (target === "user" && selectedUsers.length === 0) {
            await dialogService.handleAlert("회원을 선택해주세요.");
            return;
        }
        let _data = {
            coupon: selectedCoupon,
            count: couponCount,
        };
        if (target === "user") {
            let users = [];
            selectedUsers.forEach((element) => {
                users.push(element.id);
            });
            _data["users"] = users;
        }
        else if (target === "all") {
            _data["site"] = SITE_ID;
        }
        postData(`${BACKEND_HOST}/coupon/send/`, _data)
            .then((data) => {
            console.log(data);
            if (data.status == "ok") {
                toast.success("예약권이 성공적으로 발송되었습니다.");
            }
            else {
                toast.error(`예약권 발송에 실패했습니다.`);
            }
        })
            .catch((e) => {
            console.log(e);
            toast.error(`예약권 발송에 실패했습니다. ${e?.message}`);
        });
    };
    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="쿠폰 보내기" pageTitle="쿠폰"/>

          <Row className="g-4 mb-3">
            <div className="col-sm-auto">
              <div>
                <h4 className="card-title mb-0 flex-grow-1">쿠폰 보내기</h4>
              </div>
            </div>
            <div className="col-sm-3 ms-auto">
              {!isSending ? (<div className="d-flex justify-content-sm-end gap-2">
                  <Button color="success" className="add-btn me-1" onClick={sendToCustomers} id="create-btn">
                    보내기
                  </Button>
                </div>) : (<div className="d-flex justify-content-sm-end gap-2">
                  <Spinner color="primary"/>
                </div>)}
            </div>
          </Row>

          <Row>
            <Col xxl={12}>
              <Card>
                <CardBody>
                  <div className="live-preview">
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="reservationCoupon" className="form-label">
                            교환권 선택
                          </Label>
                          <Input type="select" className="form-control" id="reservationCoupon" placeholder="교환권을 선택해주세요." value={selectedCoupon} onChange={handleSelectedCoupon}>
                            {couponList?.map((item, index) => {
            if (moment(item["만료일"]) < moment())
                return null;
            return (<option key={index} value={item.id}>
                                  {item["id"]} {item["title"]} (만료일: {item["expire_date"]})
                                </option>);
        })}
                          </Input>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="couponCountInput" className="form-label">
                            수량
                          </Label>
                          <Input type="text" className="form-control" id="couponCountInput" placeholder="수량을 입력하세요" value={couponCount} onChange={(e) => setCouponCount(e.target.value)}/>
                        </div>
                      </Col>
                    </Row>


                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="notificationTarget" className="form-label">
                            대상
                          </Label>
                          <Input type="select" className="form-control" id="notificationTarget" placeholder="대상을 선택하세요" value={target} onChange={(e) => setTarget(e.target.value)}>
                            <option value="all">지점 전체 회원</option>
                            <option value="user">회원 선택</option>
                          </Input>
                        </div>
                      </Col>
                    </Row>
                    {target === "user" && (<Row>
                        <Col md={12}>
                          <UserSelectBox userList={userList} setUserList={setUserList} selectedUsers={selectedUsers} setSelectedUsers={setSelectedUsers} search={search} setSearch={setSearch} count={count} setCount={setCount}/>
                        </Col>
                      </Row>)}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Toaster position="top-center"/>

      </div>
    </React.Fragment>);
};
export default UserSendCoupon;
